import { type ChannelBase, getChannelBaseData } from 'models';
import { useInfiniteQuery } from 'query';
import { getChannels } from '../services';
import { getChannelsQueryKey } from './keys';

type P = {
  organizationId?: string;
  pageSize: number;
};

export const useChannelsInfiniteQuery = ({ organizationId, pageSize }: P) =>
  useInfiniteQuery<ChannelBase[], number>({
    async queryFn({ pageParam: pageParameter }) {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
      const response = await getChannels({
        limit: pageSize,
        offset: pageParameter,
        organization_id: organizationId,
      });
      /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */
      return response.data.map((entity) => getChannelBaseData(entity));
    },
    initialPageParam: 0,
    getNextPageParam(lastPage, allPages) {
      return lastPage.length < pageSize ? undefined : allPages.length * pageSize;
    },
    queryKey: getChannelsQueryKey({ organizationId, pageSize }),
  });
